"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DoorOpenSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var DoorOpenSVG = function DoorOpenSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M13 28H6a2 2 0 01-2-2V6a2 2 0 012-2h7v2H6v20h7zM27 3.8L16 1.2a1 1 0 00-.2 0 .8.8 0 00-.8.8v28a.8.8 0 00.8.8 1 1 0 00.2 0l11-2.6a1.3 1.3 0 001-1.2V5a1.3 1.3 0 00-1-1.2zM20 17a1 1 0 111-1 1 1 0 01-1 1z"
  }));
};
exports.DoorOpenSVG = DoorOpenSVG;
DoorOpenSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DoorOpenSVG);
exports.default = _default;